/**
 * ファイルのイベントを設定する
 */
$(function () {

    // ファイル選択時の処理
    $(document).on('change', '.upload_file', function(e) {
        let accept = $(this).attr('accept');
        let name = $(this).data('name');

        let fn = 'input[name=_' + name + ']';
        if ($(fn).length > 0) {
            let path = $(this).val().replace(/\\/g, '/');
            var basename = path.split('/').reverse()[0];

            if($(this).val().length > 0){
                $(fn).val(basename);
                $(".filename-" + name).html('');
                if (basename.length === 0) {
                    $('input[name=' + name + ']').val('');
                }
            }
        }

        // 画像・PDFの場合
        if (accept != null && !accept.startsWith('text')) {
            let preview = create_id($(this).data('preview'));
            var reader = new FileReader();
            reader.onload = function (e) {
                if (e.target.result.length > 0) {
                    $(".filename-" + name).html(basename);
                    if ($(preview).length > 0) {
                        $(preview).attr('src', e.target.result);
                    }
                    $('input[name=' + name + ']').val(e.target.result);
                } else {
                    $(".filename-" + name).html('File Abort!');
                    $('input[name=' + name + ']').val('');
                }
            }

            if (e.target.files.length > 0) {
                reader.readAsDataURL(e.target.files[0]);
            }
        }

        $('.delete-file-area-'+name).removeClass('display-none');
    });

    // ファイル削除時の処理
    $(document).on('click', '.delete_upload_file', function(e) {
        let uploadBtn = $($('input[name=' + $(this).data('upload') + ']'));
        let name = $(uploadBtn).data('name');
        let accept = $(uploadBtn).attr('accept');
        let defaultSrc = $(this).data('default');

        // 画像・PDFの場合
        if (accept != null && !accept.startsWith('text')) {
            let preview = create_id($(uploadBtn).data('preview'));
            if ($(preview).length > 0){
                $(preview).attr('src', defaultSrc);
            }
            $(".filename-" + name).html('');
            $('input[name=' + name + ']').val('');
            $('input[name=_' + name + ']').val('');
        }

        $('.delete-file-area-'+name).addClass('display-none');
    });
});
